import React from 'react';
import './Successpage.scss'

const SuccessPage = ({ plan_name }) => {
    return (
        <div className='message-container'>
            <div class="growing-circle1">
            </div>
            <p className='success-message'>{plan_name+" "}Plan created successfully</p>
        </div>
    )
}

export default SuccessPage
